import template from './operation-procedure.html';
import controller from './operation-procedure.controller';

const operationProcedureComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default operationProcedureComponent;
